export const COMMON_ACTIONS = {
  SET_VEHICLES: "SET_VEHICLES",
  SET_ANIMATION_VEHICLES: "SET_ANIMATION_VEHICLES",
};
